import React, { Fragment, ReactNode, useEffect } from "react";
import Helmet from "react-helmet";
import ScrollTo from "../../../../components/ScrollTo";
import useGoogleAnalytics from "../../../../hooks/useGoogleAnalytics";
import Footer from "../footer";
import Header from "../header";
//import PrimaryNav from "../../../nav/primary-nav";

export interface BaseLayoutProps {
  page: { title: string, description: string };
  className?: string;
  children: ReactNode;
}

export default function BaseLayout({ page, className, children }: BaseLayoutProps): React.JSX.Element { 
  useGoogleAnalytics();

  useEffect(() => {
    window.addEventListener("scroll", showScrollUpButton);
    
    function showScrollUpButton() {
      const btn = document.getElementById("scrollUp");
    
      if(!btn) {
        return;
      }
    
      if(window.scrollY > 300) {
        btn.classList.remove("no-display");
      } else {
        btn.classList.add("no-display");
      }
    }
  
    return () => window.removeEventListener("scroll", showScrollUpButton);
  }, []);

  return (
    <Fragment>
      <Helmet titleTemplate={`%s - ${process.env.APP_NAME}`} title={page.title}>
        <meta http-equiv="x-ua-compatible" content="ie=edge" />
        <meta name="description" content={page.description} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      {/*<link rel="shortcut icon" type="image/x-icon" href="images/favicon.png" />*/}

      {/* <!-- Cf. https://realfavicongenerator.net --> */}
      <link rel="icon" type="image/png" href="favicon/favicon-96x96.png" sizes="96x96" />
      <link rel="icon" type="image/svg+xml" href="favicon/favicon.svg" />
      <link rel="shortcut icon" href="favicon/favicon.ico" />
      <link rel="apple-touch-icon" sizes="180x180" href="favicon/apple-touch-icon.png" />
      <link rel="manifest" href="favicon/site.webmanifest" />

      {/*
      <link rel="stylesheet" href="themes/limupa/css/material-design-iconic-font.min.css" />
      <link rel="stylesheet" href="themes/limupa/css/font-awesome.min.css" />
      <link rel="stylesheet" href="themes/limupa/css/fontawesome-stars.css" />
      <link rel="stylesheet" href="themes/limupa/css/meanmenu.css" />
      <link rel="stylesheet" href="themes/limupa/css/owl.carousel.min.css" />
      <link rel="stylesheet" href="themes/limupa/css/slick.css" />
      <link rel="stylesheet" href="themes/limupa/css/animate.css" />
      <link rel="stylesheet" href="themes/limupa/css/jquery-ui.min.css" />
      <link rel="stylesheet" href="themes/limupa/css/venobox.css" />
      <link rel="stylesheet" href="themes/limupa/css/nice-select.css" />
      <link rel="stylesheet" href="themes/limupa/css/magnific-popup.css" />
      <link rel="stylesheet" href="themes/limupa/css/bootstrap.min.css" />
      <link rel="stylesheet" href="themes/limupa/css/helper.css" />
      <link rel="stylesheet" href="themes/limupa/css/style.css" />
      <link rel="stylesheet" href="themes/limupa/css/responsive.css" />

      <script src="themes/limupa/js/vendor/modernizr-2.8.3.min.js"></script>
      */}

      <div id="page-top" className={`body-wrapper ${className ?? ""}`}>
        <Header />
        {/*<PrimaryNav />*/}

        {children}

        <Footer />
        <ScrollTo 
          to="page-top" 
          id="scrollUp" 
          className="no-display"
          style={{ position: "fixed", zIndex: 2147483647 }}
        />
      </div>

      {/* <script src="themes/limupa/js/vendor/jquery-1.12.4.min.js"></script>
      <script src="themes/limupa/js/vendor/popper.min.js"></script>
      <script src="themes/limupa/js/bootstrap.min.js"></script>
      <script src="themes/limupa/js/ajax-mail.js"></script>
      <script src="themes/limupa/js/jquery.meanmenu.min.js"></script>
      <script src="themes/limupa/js/wow.min.js"></script>
      <script src="themes/limupa/js/slick.min.js"></script>
      <script src="themes/limupa/js/owl.carousel.min.js"></script>
      <script src="themes/limupa/js/jquery.magnific-popup.min.js"></script>
      <script src="themes/limupa/js/isotope.pkgd.min.js"></script>
      <script src="themes/limupa/js/imagesloaded.pkgd.min.js"></script>
      <script src="themes/limupa/js/jquery.mixitup.min.js"></script>
      <script src="themes/limupa/js/jquery.countdown.min.js"></script>
      <script src="themes/limupa/js/jquery.counterup.min.js"></script>
      <script src="themes/limupa/js/waypoints.min.js"></script>
      <script src="themes/limupa/js/jquery.barrating.min.js"></script>
      <script src="themes/limupa/js/jquery-ui.min.js"></script>
      <script src="themes/limupa/js/venobox.min.js"></script>
      <script src="themes/limupa/js/jquery.nice-select.min.js"></script>
      <script src="themes/limupa/js/scrollUp.min.js"></script>
      <script src="themes/limupa/js/main.js"></script> */}
    </Fragment>
  );
}
